module.exports = __webpack_public_path__ + "img/on-boarding.6a3ec2f9.svg";